import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private apiUrl = '/api/v1/feature_flags';

  constructor(private http: HttpClient) {}

  isFeatureEnabled(featureName: string, organizationId = 0): Observable<boolean> {
    return this.http.get<any>(`${this.apiUrl}?name=${featureName}&organization_id=${organizationId}`)
      .pipe(
        map(response => {
          if (response.code === 'success' && response.data) {
            return response.data[featureName] === true;
          }
          return false;
        })
      );
  }

  isAgeVerificationEnabled(organizationId = 0): Observable<boolean> {
    return this.isFeatureEnabled('AGE_VERIFICATION_ENABLED', organizationId);
  }
} 